import * as React from 'react';
import { createElement } from 'react';
import './index.scss';
import { Box, Table, Pagination, } from '@alifd/next';
import EmptyBlock from './EmptyBlock';
import { entityDataUtil, entityMetadataUtil, eventBusUtil } from 'oadp-common';
import OadpTableColumn from '../oadp-table-column';
export class OadpEntityTable extends React.Component {
    constructor(props) {
        super(props);
        this.topBoxRef = React.createRef();
        this.paginationRef = React.createRef();
        this.updateTableMaxBodyHeight = () => {
            if (this.topBoxRef.current && this.paginationRef.current) {
                const topBoxHeight = this.topBoxRef.current.clientHeight;
                let paginationHeight = this.paginationRef.current.clientHeight;
                paginationHeight = paginationHeight < 50 ? 50 : paginationHeight;
                const tableMaxBodyHeight = window.innerHeight - topBoxHeight - paginationHeight - 50 - 40;
                const tableMaxHeight = window.innerHeight - topBoxHeight - paginationHeight - 50;
                if (this.state.tableMaxBodyHeight !== tableMaxBodyHeight) {
                    this.setState({ tableMaxBodyHeight, tableMaxHeight });
                }
            }
        };
        this.handleRowSelectionUpdate = () => {
            const { rowSelectionMode, __designMode } = this.props;
            console.log('handleRowSelectionUpdate ', rowSelectionMode);
            try {
                if (rowSelectionMode !== 'disabled') {
                    this.setState({
                        rowSelection: {
                            onChange: this.rowSelectionOnChange,
                            onSelect: (selected, record, records) => {
                                console.log('onSelect', selected, record, records);
                            },
                            onSelectAll: (selected, records) => {
                                console.log('onSelectAll', selected, records);
                            },
                            selectedRowKeys: [],
                            mode: rowSelectionMode,
                            columnProps: () => ({
                                width: 40,
                                align: 'center',
                                alignHeader: 'center',
                                lock: __designMode === 'design' ? false : 'left',
                            }),
                            getProps: record => ({})
                        }
                    });
                }
                else {
                    this.setState({ rowSelection: undefined });
                }
            }
            catch (error) {
                console.log('handleRowSelectionUpdate error ', error);
            }
        };
        this.handleRefreshTableDataSourceEvent = (payload) => {
            console.log("OadpEntityTable handleRefreshTableDataSourceEvent:", payload, this.props);
            if (payload.tableComponentRefId === this.props.__id) {
                this.initDataSource(payload);
            }
        };
        this.handleRefreshTableColumnEvent = (payload) => {
            console.log("OadpEntityTable handleRefreshTableColumnEvent: ", payload, this.props);
            if (payload.tableComponentRefId === this.props.__id && payload && payload.showColumnList) {
                const { children } = this.props;
                const { attributeDataSource } = this.state;
                let newChildren = [];
                payload.showColumnList.forEach((showColumn) => {
                    console.log('OadpEntityTable handleRefreshTableColumnEvent item', showColumn, children);
                    let findOldChild = children.find((child) => child.props.dataIndex === showColumn);
                    console.log('OadpEntityTable handleRefreshTableColumnEvent: findOldChild', findOldChild);
                    if (findOldChild) {
                        newChildren.push(findOldChild);
                    }
                    else {
                        let logicalName = showColumn.includes('.')
                            ? showColumn.split('.')[0]
                            : showColumn;
                        let findAttribute = attributeDataSource.find((attribute) => attribute.logicalName === logicalName);
                        console.log('OadpEntityTable handleRefreshTableColumnEvent: ', attributeDataSource, findAttribute);
                        if (findAttribute) {
                            let dataIndex = findAttribute.logicalName;
                            if (findAttribute.attributeType.code === 'REFER') {
                                dataIndex = findAttribute.logicalName + '.name';
                            }
                            newChildren.push(createElement(OadpTableColumn, { key: findAttribute.logicalName, dataIndex: dataIndex, title: findAttribute.name, width: 200, align: 'center' }));
                        }
                    }
                    console.log('OadpEntityTable handleRefreshTableColumnEvent: newChildren', newChildren);
                });
                if (newChildren) {
                    let attributeShowList = [];
                    newChildren.forEach((child) => {
                        attributeShowList.push(child.props.dataIndex);
                    });
                    this.setState({
                        dynamicChildren: newChildren,
                        attributeShowDataSource: attributeShowList
                    });
                }
            }
        };
        this.handleResize = () => {
            this.updateTableMaxBodyHeight();
        };
        this.handleFilterRuleToCondition = (filterCondition, field) => {
            console.log('handleFilterRuleToCondition begin with filterCondition', filterCondition, field);
            if (!filterCondition)
                return;
            let newFilterCondition = { ...filterCondition };
            if (filterCondition.operator === 'or' || filterCondition.operator === 'and') {
                newFilterCondition.value = filterCondition.value.map(item => this.handleFilterRuleToCondition(item, field));
            }
            else {
                if (filterCondition.valueType === 'ATTRIBUTE') {
                    const attributeValueLogicalName = filterCondition.value;
                    newFilterCondition.value = field.getValue(attributeValueLogicalName);
                }
            }
            console.log('handleFilterRuleToCondition end with newFilterCondition', newFilterCondition);
            return newFilterCondition;
        };
        this.initDataSource = async (payload) => {
            console.log('initDataSource', this.props, payload, this.state);
            const { entity, filterRule } = this.props;
            if (!entity) {
                console.log('OadpEntityTable initDataSource entity is empty');
                return;
            }
            if (!this.state.needInitDataSource) {
                console.log('OadpEntityTable initDataSource needInitDataSource is false');
                return;
            }
            const entityWithRefer = await entityMetadataUtil.asyncSelectEntityWithReferById(entity);
            console.log('OadpEntityTable initDataSource entityWithRefer', entityWithRefer);
            if (!entityWithRefer) {
                console.log('OadpEntityTable initDataSource entityWithRefer is empty');
                return;
            }
            try {
                let condition = null;
                if (filterRule) {
                    condition = this.handleFilterRuleToCondition(filterRule, entity);
                }
                if (payload && payload.pageNum && payload.pageNum !== this.state.pageNum) {
                    this.setState({
                        pageNum: payload.pageNum
                    });
                }
                if (payload && payload.pageSize && payload.pageSize !== this.state.pageSize) {
                    this.setState({
                        pageSize: payload.pageSize
                    });
                }
                if (payload && payload.readFastCondition) {
                    if (condition) {
                        condition = {
                            operator: 'and',
                            value: [payload.readFastCondition, condition]
                        };
                    }
                    else {
                        condition = payload.readFastCondition;
                        console.log('OadpEntityTable initDataSource condition', condition, payload.readFastCondition);
                    }
                    console.log('OadpEntityTable initDataSource condition', condition);
                }
                const response = await entityDataUtil.asyncSelectPageListWithReferByCondition(entityWithRefer.logicalName, {
                    "model": entityWithRefer.logicalName,
                    condition,
                    "orderBy": [
                        {
                            "attribute": "updateAt",
                            "operator": "desc"
                        }
                    ],
                    "pageNum": this.state.pageNum,
                    "pageSize": this.state.pageSize
                });
                console.log('response', response);
                var entityTableDataSource = response.data.list;
                var total = response.data.total;
                this.setState({
                    entityTableDataSource,
                    pageNum: response.data.pageNum,
                    pageSize: response.data.pageSize,
                    total
                });
            }
            catch (error) {
                console.error('OadpEntityTable initDataSource error:', error);
            }
        };
        this.onPageNumChange = (pageNum, e) => {
            console.log('onPageNumChange begin with pageNum:', pageNum);
            this.setState({ pageNum }, () => {
                this.initDataSource();
            });
            console.log('onPageNumChange begin with pageNum:', this.state.pageNum);
        };
        this.onPageSizeChange = (pageSize) => {
            console.log('onPageSizeChange begin with pageSize:', pageSize);
            this.setState({ pageSize }, () => {
                this.initDataSource();
            });
            console.log('onPageSizeChange end ');
        };
        this.renderChildren = () => {
            const { __designMode, children } = this.props;
            if (__designMode === 'design') {
                console.log('renderChildren', children, __designMode);
                return children;
            }
            else {
                console.log('renderChildren', this.state.dynamicChildren, __designMode);
                return this.state.dynamicChildren;
            }
        };
        this.renderRowButtonBar = (cellData, rowData, rowIndex) => {
            const { rowButtonBar } = this.props;
            return rowButtonBar ? createElement(Box, { style: { width: '100%' } }, rowButtonBar()) : null;
        };
        this.state = {
            entityTableDataSource: [],
            readFastCondition: null,
            needInitDataSource: true,
            pageNum: 1,
            pageSize: props.pageSize | 20,
            total: 0,
            visibleTableSetting: false,
            attributeDataSource: [],
            attributeShowDataSource: [],
            transferTargetValue: [],
            transferTargetDataSource: [],
            tableMaxBodyHeight: 500,
            tableMaxHeight: 550,
            rowSelection: {
                onChange: this.rowSelectionOnChange.bind(this),
                onSelect: function (selected, record, records) {
                    console.log('onSelect', selected, record, records);
                },
                onSelectAll: function (selected, records) {
                    console.log('onSelectAll', selected, records);
                },
                selectedRowKeys: [],
                mode: this.props.rowSelectionMode,
                getProps: record => {
                    return {};
                },
            },
        };
        this.rowSelectionOnChange = this.rowSelectionOnChange.bind(this);
    }
    async componentDidMount() {
        const { entity, children, rowSelectionMode, preLockAttributeList, postLockAttributeList, __designMode } = this.props;
        console.log('OadpEntityTable componentDidMount this.props', this.props);
        if (!entity) {
            console.log('OadpEntityTable componentDidMount entity is undefined');
        }
        else {
            const attributeData = await entityMetadataUtil.asyncSelectAttributeListWithReferByEntityId(entity);
            console.log('OadpEntityTable componentDidMount attributeData', attributeData);
            attributeData.list.forEach((item) => {
                item.label = item.name;
                item.value = item.logicalName;
                if (item.attributeType.code === 'REFER') {
                    item.value = item.logicalName + '.name';
                }
            });
            this.setState({
                attributeDataSource: attributeData.list
            });
        }
        if (rowSelectionMode !== 'disabled') {
            this.setState({
                rowSelection: {
                    onChange: this.rowSelectionOnChange,
                    onSelect: function (selected, record, records) {
                        console.log('onSelect', selected, record, records);
                    },
                    onSelectAll: function (selected, records) {
                        console.log('onSelectAll', selected, records);
                    },
                    selectedRowKeys: [],
                    mode: rowSelectionMode,
                    columnProps: () => ({
                        width: 40,
                        align: 'center',
                        alignHeader: 'center',
                    }),
                    getProps: record => { }
                }
            });
        }
        else {
            this.setState({
                rowSelection: undefined
            });
        }
        let preLockLogicalNameList = [];
        this.state.attributeDataSource.find((item) => {
            if (preLockAttributeList.includes(item.id)) {
                let logicalName = item.logicalName;
                if (item.attributeType.code === 'REFER') {
                    logicalName = item.logicalName + '.name';
                }
                preLockLogicalNameList.push(logicalName);
            }
        });
        console.log('OadpEntityTable componentDidMount preLockAttributeList', this.state.attributeDataSource, preLockAttributeList);
        let postLockLogicalNameList = [];
        this.state.attributeDataSource.find((item) => {
            if (postLockAttributeList.includes(item.id)) {
                let logicalName = item.logicalName;
                if (item.attributeType.code === 'REFER') {
                    logicalName = item.logicalName + '.name';
                }
                postLockLogicalNameList.push(logicalName);
            }
        });
        console.log('OadpEntityTable componentDidMount postLockAttributeList', this.state.attributeDataSource, postLockAttributeList);
        const processedChildren = children.map(element => {
            if (preLockLogicalNameList.length > 0) {
                if (preLockLogicalNameList.includes(element?.props?.dataIndex)) {
                    element.props.lock = __designMode === 'design' ? false : 'left';
                    element.props.width = 200;
                    console.log('OadpEntityTable componentDidMount __designMode preLockLogicalNameList', __designMode, element.props.lock, element);
                }
            }
            if (postLockLogicalNameList.length > 0) {
                if (postLockLogicalNameList.includes(element?.props?.dataIndex)) {
                    element.props.lock = __designMode === 'design' ? false : 'right';
                    element.props.width = 200;
                    console.log('OadpEntityTable componentDidMount __designMode', postLockLogicalNameList, __designMode, element.props.lock, element);
                }
            }
            return element;
        });
        this.setState({
            dynamicChildren: processedChildren || []
        });
        if (children && Array.isArray(children)) {
            let attributeShowList = [];
            children.forEach((child) => {
                attributeShowList.push(child.props.dataIndex);
            });
            this.setState({
                attributeShowDataSource: attributeShowList
            });
        }
        console.log('OadpEntityTable componentDidMount attributeShowDataSource', this.state.attributeShowDataSource);
        this.initDataSource();
        this.updateTableMaxBodyHeight();
        window.addEventListener('resize', this.handleResize);
        eventBusUtil.on("refreshOadpEntityTableDataSource", this.handleRefreshTableDataSourceEvent);
        eventBusUtil.on("refreshOadpEntityTableColumn", this.handleRefreshTableColumnEvent);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.entity !== this.props.entity) {
            this.initDataSource();
        }
        this.updateTableMaxBodyHeight();
        if (prevProps.rowSelectionMode !== this.props.rowSelectionMode) {
            this.handleRowSelectionUpdate();
        }
    }
    componentWillUnmount() {
        eventBusUtil.off("refreshOadpEntityTableDataSource", this.handleRefreshTableDataSourceEvent);
        eventBusUtil.off("refreshOadpEntityTableColumn", this.handleRefreshTableColumnEvent);
        window.removeEventListener('resize', this.handleResize);
    }
    rowSelectionOnChange(ids, records) {
        const { rowSelection } = this.state;
        rowSelection.selectedRowKeys = ids;
        console.log('rowSelectionOnChange', ids, records);
        this.setState({ rowSelection });
    }
    render() {
        console.log('OadpEntityTable render', this.props);
        console.log('OadpEntityTable render tableMaxBodyHeight ', this.state.tableMaxBodyHeight);
        console.log('OadpEntityTable render entityTableDataSource', this.state.entityTableDataSource);
        const { enableTableQueryBar, tableQueryBar, enableTableButtonBar, tableButtonBar, enableRowButtonBar, rowButtonBar, tableWidth, pageType, pageButton, pageShowCount, pageSizeSelector, pageSizeList, children, enableSerialNumber, __designMode } = this.props;
        return (createElement(Box, null,
            createElement("div", { ref: this.topBoxRef },
                createElement(Box, { direction: "column", justify: 'start', align: 'center' },
                    enableTableQueryBar ?
                        createElement(Box, { style: { width: '100%', marginBottom: 5 } }, tableQueryBar ? createElement(Box, { style: { width: '100%' } }, tableQueryBar()) : null)
                        : null,
                    enableTableButtonBar ?
                        createElement(Box, { direction: "row", justify: 'end', style: { width: '100%', marginBottom: 5 } }, tableButtonBar ? createElement(Box, { style: { width: '100%' } }, tableButtonBar()) : null)
                        : null)),
            createElement("div", { entity_table_data_div_id: this.props.__id, table_select_row_ids: this.state && this.state.rowSelection && this.state.rowSelection.selectedRowKeys ? this.state.rowSelection.selectedRowKeys : '', table_attribute_show_datasource: this.state && this.state.attributeShowDataSource ? this.state.attributeShowDataSource : '', table_attribute_datasource: this.state && this.state.attributeDataSource ? this.state.attributeDataSource : '' }),
            createElement("div", { style: { width: '100%', height: this.state.tableMaxBodyHeight + 50, border: '1px solid #DADBDF' } },
                createElement(Table, { hasBorder: false, fixedHeader: true, emptyContent: createElement(EmptyBlock, null), tableWidth: tableWidth, dataSource: this.state.entityTableDataSource, maxBodyHeight: this.state.tableMaxBodyHeight, rowSelection: this.state.rowSelection },
                    enableSerialNumber ?
                        createElement(OadpTableColumn, { title: "#", width: 80, align: 'center', cell: (rowData, rowIndex) => ((this.state.pageNum - 1) * this.state.pageSize + rowIndex + 1), lock: __designMode === 'design' ? false : 'left' })
                        : null,
                    __designMode === 'design' ? children : this.state.dynamicChildren,
                    enableRowButtonBar ?
                        createElement(OadpTableColumn, { title: "\u64CD\u4F5C", dataIndex: "_oadpEntityRowOperate", width: 200, align: 'center', cell: this.renderRowButtonBar, lock: __designMode === 'design' ? false : 'right' })
                        : null)),
            createElement("div", { ref: this.paginationRef },
                createElement(Box, { direction: "row", justify: 'end', style: { width: '100%', height: '50' } },
                    createElement(Box, { direction: "row", justify: 'start', align: 'center', style: { width: '30%' } },
                        createElement(Box, { className: "next-pagination-size-selector-title", style: { color: '#999' } },
                            "\u5DF2\u9009 ",
                            this.state.rowSelection?.selectedRowKeys?.length || 0,
                            " \u6761")),
                    createElement(Box, { direction: "row", justify: 'end', align: 'center', style: { width: '70%' } },
                        createElement(Pagination, { size: 'medium', pageSizePosition: 'end', type: pageType, shape: pageButton, total: this.state.total, totalRender: total => (createElement(Box, { className: "next-pagination-size-selector-title", style: { color: '#999' } },
                                "\u5171\u8BA1 ",
                                total || 0,
                                " \u6761")), pageShowCount: pageShowCount, current: this.state.pageNum, pageSize: this.state.pageSize, pageSizeSelector: pageSizeSelector, pageSizeList: pageSizeList, style: { marginTop: "5px", marginBottom: "5px" }, onChange: this.onPageNumChange, onPageSizeChange: this.onPageSizeChange }))))));
    }
}
export default OadpEntityTable;
